import { render, staticRenderFns } from "./registerSuccess.vue?vue&type=template&id=8449124a&scoped=true&"
import script from "./registerSuccess.vue?vue&type=script&lang=js&"
export * from "./registerSuccess.vue?vue&type=script&lang=js&"
import style0 from "./registerSuccess.vue?vue&type=style&index=0&id=8449124a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8449124a",
  null
  
)

export default component.exports